import { AxiosError } from 'axios'

import { api } from '../libs/axios'
import store from '../reducers'
import { setIsLoading } from '../reducers/appReducer'
import { setIsAuthenticated } from '../reducers/authReducer'
import { getLoggedUser } from './appServices'

interface AuthRequest {
  email: string
  password: string
}

export async function createSession({
  email,
  password,
}: AuthRequest) {
  const dispatch = store.dispatch
  dispatch(setIsLoading(true))
  try {
    const session = await api.post('/sessions', { email, password })

    api.defaults.headers.common['Authorization'] = `Bearer ${session.data.token}`

    await getLoggedUser(session.data.token)

    dispatch(setIsAuthenticated(true))
    return {
      data: session.data,
      success: true,
      message: 'Login realizado com sucesso',
    }
  } catch (err) {
    if (err instanceof AxiosError) {
      return {
        data: undefined,
        success: false,
        message: err.response?.data.message || 'Erro ao realizar login',
      }
    }
  } finally {
    dispatch(setIsLoading(false))
  }
}

export async function checkUserEmail(email: string) {
  try {
    const { data } = await api.post('/users/check', {
      email,
    })

    return {
      userId: data.userId,
    }
  } catch (err) {
    if (err instanceof AxiosError) {
      return {
        message: err.response?.data.message,
      }
    }
  }
}

export interface CompleteUserProfileRequest {
  id: string
  avatar?: File
  phone: string
  name: string
  password: string
}

interface CompleteUserProfileResponse {
  user?: {
    id: string
    email: string
    is_active: boolean
    avatar_url: string
  }
}

export async function completeUserProfile(
  body: CompleteUserProfileRequest,
) {
  try {
    const formData = new FormData()
    Object.entries(body).forEach(([key, value]) => {
      const param = key.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()
      formData.append(param, value)
    })
    const { data } = await api.post<CompleteUserProfileResponse>('/users/activate', formData)

    return {
      user: data.user,
      success: true,
      message: 'Usuário ativado!',
    }
  } catch (err) {
    if (err instanceof AxiosError) {
      return {
        user: undefined,
        success: false,
        message: err.response?.data.message || 'Arro ao ativar usuário',
      }
    }
  }
}
